// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__LPSl8","title":"style_title__UJuf0","body":"style_body__7THPa"};